// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M9.563 1.52a.751.751 0 0 0-.119 1.412l.12.056 3.408.014c3.669.015 3.522.01 4.155.141a6.868 6.868 0 0 1 2.66 1.2 6.783 6.783 0 0 1 2.45 3.559 6.867 6.867 0 0 1 .058 3.474 6.755 6.755 0 0 1-1.171 2.448c-.272.363-.937 1.028-1.302 1.301-.912.684-1.893 1.098-3.07 1.297-.3.051-.301.051-7.236.059l-6.935.008 1.658-1.663c1.59-1.592 1.661-1.668 1.712-1.806a.8.8 0 0 0-.025-.598.894.894 0 0 0-.433-.387.87.87 0 0 0-.573.035c-.078.04-.768.714-2.453 2.397C-.18 17.11-.013 16.92.004 17.277a.686.686 0 0 0 .065.294c.077.151 4.722 4.793 4.863 4.859.06.028.168.048.293.054.17.008.213 0 .328-.052a.826.826 0 0 0 .401-.422.814.814 0 0 0-.027-.592c-.045-.092-.414-.476-1.7-1.768L2.581 18l6.923-.006c7.673-.008 7.079.004 7.899-.163a8.241 8.241 0 0 0 4.27-2.343 8.231 8.231 0 0 0 2.205-4.316 8.718 8.718 0 0 0 .036-2.62 8.248 8.248 0 0 0-2.946-5.195c-1.243-1.017-2.679-1.618-4.361-1.824-.343-.042-6.88-.053-7.045-.012"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const KeyboardArrowReturnIcon = Icon;
export default KeyboardArrowReturnIcon;
